module.exports = __webpack_public_path__ + "img/17.aa1ec342.png";